import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/pages/home-page/HomePageComponent.tsx");
